/**
 * Capitalizes each segment's first letter without changing the saved name,
 * its spacing, its punctuation, or the casing of its remaining letters.
 */
const formatBusinessName = (name) => {
  if (typeof name !== "string") {
    return name;
  }

  let capitalizeNextLetter = true;

  return Array.from(name, (character) => {
    if (/\p{L}/u.test(character)) {
      if (capitalizeNextLetter) {
        capitalizeNextLetter = false;
        return character.toLocaleUpperCase();
      }

      return character;
    }

    // A number can precede the first actual letter, as in "305 pizza".
    if (!/\p{N}/u.test(character)) {
      capitalizeNextLetter = true;
    }

    return character;
  }).join("");
};

export default formatBusinessName;
